export const font = {
  bold: 'OpenSans-Bold',
  regular: 'OpenSans-Regular',
  semibold: 'OpenSans-Semibold',
};

export const fontWeight = {
  bold: 700,
  regular: 400,
  semibold: 600,
};

export type ThemeFont = keyof typeof font;

export type ThemeFontWeight = keyof typeof fontWeight;
